import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_BUTTON,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,
    name: FONT_FAMILY.name,
    fullName: FONT_FAMILY.fullName,
    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '45px',
    body: '16px',
    body_lv2: '14px',
    name: '40px',
    fullName: '20px',
  },
  fontWeights: {
    heading: 400,
    body: 400,
    body_lv2: 400,
    name: 400,
    fullName: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-name': '',
        '--fontItalic-fullName': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(242,237,226,1)',
    bgSecondary: 'rgba(199,199,186,1)',
    bgAlternative: 'rgba(145,152,137,1)',
    mainColorText: 'rgba(93,102,84,1)',
    secondaryColorText: 'rgba(51,61,45,1)',
    alternativeColorText: 'rgba(93,102,84,1)',
    btnColorText: '#F0EDE6',
    transparent: 'transparent',
    theme: {
      bgPrimary: BG_PRIMARY,
      bgSecondary: BG_SECONDARY,
    },
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
